import { faCog } from '@fortawesome/free-solid-svg-icons';
import { buildSettingsModules } from '@ui/SettingsPanel';
import i18n from 'i18n';
import { NavItem } from './useCommandPaletteStore';

/**
 * Returns Cmd+K nav items for all known settings sections, derived from the shared
 * settings config (the same metadata the pages render). Pre-registered on layout mount
 * so sections are discoverable even before the user visits a settings page this session.
 *
 * The subtitle is prefixed with the parent module name so that sections sharing a title
 * across modules (e.g. "Rechnungseinstellungen", "Benachrichtigungen") stay distinguishable.
 *
 * @param availableSegments When provided, only modules whose url segment is in this set are
 *   registered — so Cmd+K never surfaces settings for modules absent from the user's nav.
 */
export function getSettingsSectionNavItems(clubSlug: string, availableSegments?: Iterable<string>): NavItem[] {
    const allow = availableSegments ? new Set(availableSegments) : null;

    return buildSettingsModules(i18n.getFixedT(null, 'settings')).flatMap((mod) => {
        if (!mod.active) return [];
        if (allow && !allow.has(mod.segment)) return [];
        const baseUrl = `/club/${clubSlug}/${mod.segment}/settings`;
        return mod.sections.map((s) => ({
            id: `settings-section::${baseUrl}::${s.id}`,
            label: s.title,
            module: mod.name,
            // Keywords are synonyms, not part of the display name — feed them to search via tags.
            tags: s.keywords ? [s.keywords] : undefined,
            url: `${baseUrl}?section=${s.id}`,
            icon: faCog,
            // Settings sections rank below pages/tabs so navigation results surface first.
            demoted: true,
        }));
    });
}
